import { render, staticRenderFns } from "./CadastrarTecnicoServico.vue?vue&type=template&id=1a2c4952&scoped=true"
import script from "./CadastrarTecnicoServico.vue?vue&type=script&lang=js"
export * from "./CadastrarTecnicoServico.vue?vue&type=script&lang=js"
import style0 from "./CadastrarTecnicoServico.vue?vue&type=style&index=0&id=1a2c4952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c4952",
  null
  
)

export default component.exports